import script from "./Typing.vue?vue&type=script&setup=true&lang=js"
export * from "./Typing.vue?vue&type=script&setup=true&lang=js"

import "./Typing.vue?vue&type=style&index=0&id=5991a3ea&lang=sass&scoped=true"

import exportComponent from "/Users/yablonev/Desktop/Yablonev/Coding/GitHub/TON/Highload-UI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5991a3ea"]])

export default __exports__